var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeShow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Eye Show"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6.85c-8.632 0-16.274 5.257-19.394 13.095l-.22.555.22.555C3.726 28.893 11.368 34.15 20 34.15c8.632 0 16.274-5.257 19.395-13.095l.22-.555-.22-.555C36.273 12.106 28.63 6.85 20 6.85Zm.375 3.004c6.99.144 13.167 4.307 15.947 10.527l.05.119-.05.12c-2.83 6.33-9.178 10.53-16.323 10.53l-.375-.004c-6.99-.144-13.167-4.308-15.946-10.527l-.052-.119.052-.12C6.506 14.05 12.855 9.85 20 9.85l.375.004ZM20 12.5a7.492 7.492 0 0 0-7.5 7.5c0 4.148 3.352 7.5 7.5 7.5s7.5-3.352 7.5-7.5-3.352-7.5-7.5-7.5Zm0 3c2.491 0 4.5 2.009 4.5 4.5s-2.009 4.5-4.5 4.5a4.492 4.492 0 0 1-4.5-4.5c0-2.491 2.009-4.5 4.5-4.5Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/EyeShow.90ab639e2e6bf3aed887326087030f21.svg";
export { ForwardRef as ReactComponent };